import type { useAttempt } from "~/hooks";

export type Color = string;
export type Maybe<T> = T | null | undefined;
export type MaybeArray<T> = T | T[];

export type AttemptState = ReturnType<typeof useAttempt>;

export const convertEmptyStringsToNulls = (obj: object) => {
  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => {
      if (value === "") {
        return [key, null];
      }
      return [key, value];
    }),
  );
};

export const removeNullsFromObject = (obj: object) => {
  return Object.fromEntries(Object.entries(obj).filter(([_, v]) => v != null));
};

export const QueryKey = {
  Apps: "apps",
  AthleteStatuses: "athleteStatuses",
  Compact: "compact",
  DefaultAppRules: "defaultAppRules",
  Linkable: "linkable",
  Listing: "listing",
  Org: "orgs",
  Teams: "teams",
  People: "people",
  PartialMatch: "partialMatch",
  DuplicateProfiles: "duplicateProfiles",
  TeamProductResources: "teamProductResources",
  UserTypes: "userTypes",
  SportDataProviders: "sportDataProviders",
} as const;
export type QueryKey = (typeof QueryKey)[keyof typeof QueryKey];
